import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../Layout/DocumentationSidebar";
import TopMenu from "../TopMenu";
import TableDocument from "./TableDocument";
import FilterModal from "../../../Components/Common/FilterModal";
import { api, get } from "../../../utils/api";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";

const Governance = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [travelFilter, setTravelFilter] = useState({
    title: "",
  });

  const [searchQuery, setSearchQuery] = useState("");

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async () => {
    try {
      let url = `${api}/governance/documents/all`;
      const params = [];
      if (searchQuery) params.push(`search=${encodeURIComponent(searchQuery)}`);
      // Add more filters here if needed, e.g.:
    

      if (params.length) url += `?${params.join("&")}`;

      const response = await get(url);
      setData(response.data.data || []);
      setTotalPages(1);
    } catch (error) {
      console.error("Error fetching governance documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    {
      title: "Title",
      key: "title",
    },
    {
      title: "Status",
      key: "status",
    },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Title",
      type: "option",
      key: "titles",
      value: travelFilter?.titles
        ? travelFilter.titles
        : [],
    },
   
  ].filter(Boolean);

  const toggleData = [];
  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData: toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
            facilityRequired: "false",
            fetchData,
            setSearchQuery,
          }}
          heading={"Governance"}
        />

        <TableDocument
          data={data}
          totalPages={totalPages}
          page={page}
          handleChangePage={handleChangePage}
          headers={heading}
          columnWidth={"25% 25% 25% 25%"}
        />

        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={filterData}
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Governance;
